// @ts-nocheck
import { Formio } from "@formio/angular";
const Base = (Formio as any).Components.components.component;
const editForm = (Formio as any).Components.components.table.editForm;
const Components = (Formio as any).Components;
const TextAreaeditForm = (Formio as any).Components.components.textarea.editForm;
const Templates = (Formio as any).Templates;
const Utils = (Formio as any).Utils;
const TextFieldComponent = (Formio as any).Components.components.htmlelement;
import * as _ from "lodash";
import tinymce from "tinymce/tinymce.min.js";

function uuidv4(): string {
  return "ikbsxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

Templates.current = {
  smytemplate: {
    form: (ctx) => `
        <label  class="${componentID}1" for="e3sm85-file" class="col-form-label" ref="label">
            ${ctx.component.label}
        </label>
        <textarea  class="${componentID}" style="width:100%;" aria-label="editor"></textarea>`,
  },
};

export default class IKBSTinyMce extends Base {
  public componentID = uuidv4();
  static editForm = editForm;

  static schema() {
    return Base.schema({
      type: "IKBSTinyMce",
      label: "Editor",
    });
  }

  static builderInfo = {
    title: "TinyMCE Editor",
    group: "basic",
    icon: "fa fas tool",
    weight: 70,
    documentation: "http://help.form.io/userguide/#table",
    schema: IKBSTinyMce.schema(),
  };

  constructor(component, options, data) {
    super(component, options, data);
    super.init();
  }

  init() {
    console.log(this.componentID);
    // Убираем инициализацию TinyMCE отсюда, чтобы избежать дублирования
    super.init();
  }

  render(children) {
    return super.render(`
        <label  class="${this.componentID}1" for="e3sm85-file" class="col-form-label" ref="label">
           ${this.component.label}
        </label>
        <textarea id="${this.componentID}" class="${this.componentID}" style="width:100%;" aria-label="editor"></textarea>`);
  }

  attach(element) {
    console.log('attach')
    const editorSelector = `#${this.componentID}`;

    setTimeout(() => {
      tinymce.init({
        min_height: 400,
        selector: editorSelector,
        plugins: "lists link image help wordcount code autoresize   advlist  anchor  autolink autoresize autosave  charmap  code codesample directionality  emoticons    fullscreen help image importcss  insertdatetime link  lists media    nonbreaking pagebreak    preview quickbars save searchreplace table  template     visualblocks visualchars wordcount",
        toolbar:
          "  accordion addcomment aidialog aishortcuts aligncenter alignjustify alignleft alignnone alignright | anchor | blockquote  | backcolor | bold | casechange checklist copy cut | fontsize forecolor h1 h2 h3 h4 h5 h6 hr indent | italic | language | lineheight |  outdent | paste pastetext | redo | remove removeformat | selectall | strikethrough | styles | subscript superscript underline | undo | visualaid  a11ycheck advtablerownumbering revisionhistory typopgraphy restoredraft casechange charmap checklist code codesample addcomment showcomments ltr rtl editimage fliph flipv imageoptions rotateleft rotateright emoticons export footnotes footnotesupdate formatpainter fullscreen help image insertdatetime link openlink unlink bullist numlist media mergetags mergetags_list nonbreaking pagebreak pageembed permanentpen preview  quicklink quicktable  searchreplace showcomments spellcheckdialog spellchecker | table tablecellprops tablecopyrow tablecutrow tabledelete tabledeletecol tabledeleterow tableinsertdialog tableinsertcolafter tableinsertcolbefore tableinsertrowafter tableinsertrowbefore tablemergecells tablepasterowafter tablepasterowbefore tableprops tablerowprops tablesplitcells tableclass tablecellclass tablecellvalign tablecellborderwidth tablecellborderstyle tablecaption tablecellbackgroundcolor tablecellbordercolor tablerowheader tablecolheader | tableofcontents tableofcontentsupdate | visualblocks visualchars | wordcount ",
        browser_spellcheck: true,
        menubar: true,
        setup: (editor) => {
          // Обработка изменений содержимого для синхронизации с Formio
          editor.on("change keyup", (e) => {
            // Получаем актуальное содержимое из редактора
            const content = editor.getContent();
            // Синхронизируем только с Formio, не трогаем редактор
            this.syncWithFormio(content);
          });
        },
      });
    }, 100);
    return super.attach(element);
  }

  //
  /**
   * Синхронизирует содержимое только с Formio, не затрагивая редактор
   */
  syncWithFormio(content) {
    // Вызываем только родительский setValue без обновления редактора
    super.setValue(content);
  }

  setValue(value, flags = {}) {
    if (!value) value = "";

    // Проверяем, есть ли уже инициализированный редактор
    const editor = tinymce.get(this.componentID);
    if (!editor) {
      console.warn(`TinyMCE instance for ${this.componentID} not found. Retrying...`);
      const myInterval = setInterval(() => {
        const retryEditor = tinymce.get(this.componentID);
        if (retryEditor) {
          // Устанавливаем контент только при инициализации
          retryEditor.setContent(value);
          clearInterval(myInterval);
        }
      }, 500);
    } else {
      // Проверяем, отличается ли новое значение от текущего
      const currentContent = editor.getContent();
      if (currentContent !== value) {
        // Устанавливаем контент только если он действительно изменился извне
        editor.setContent(value);
      }
    }

    return super.setValue(value, flags);
  }
}

IKBSTinyMce.editForm = (...args) => {
  const editForm = TextAreaeditForm(...args);
  const editor = Utils.getComponent(editForm.components, "editor");
  editor.hidden = true;
  return editForm;
};

// Register the component to the Formio.Components registry.
Components.addComponent("IKBSTinyMce", IKBSTinyMce);
